import Vue from 'vue'

export const daysService = {
  getClosedDays,
  getPackagingDay,
  getNextWorkingDay,
  getNextWorkingDayDPD,
  getNextWorkingDayPostNL,
  getNextPostNLDeliveryDay,
  getNextDPDDeliveryDay,
  getNextDPDDeliveryDayByCountry,
  getNextDeliveryDay
}

function getClosedDays () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/closed-days'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getPackagingDay (now) {
  return new Promise((resolve, reject) => {
    getClosedDays()
      .then((dates) => {
        if (now === null) {
          now = new Date()
        }
        if (now.getHours() >= 14) {
          now.setDate(now.getDate() + 1) // add days
        }
        if (now.getDay() === 0) { // sunday
          now.setDate(now.getDate() + 1) // add another day
        } else if (now.getDay() === 6) { // saturday
          now.setDate(now.getDate() + 2) // add another day
        }
        while (dates.includes(now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2))) {
          now.setDate(now.getDate() + 1)
        }
        now.setHours(0, 0, 0, 0)
        resolve(now)
      }, (error) => {
        return reject(error)
      })
  })
}

async function getNextWorkingDayDPD (now, total) {
  let nextWorkingDay = await getNextWorkingDay(now, 6)
  for (var i = 1; i < total; i++) {
    nextWorkingDay = await getNextWorkingDay(nextWorkingDay, 6)
  }
  return nextWorkingDay
}

async function getNextWorkingDayPostNL (now, total) {
  let nextWorkingDay = await getNextWorkingDay(now, 1)
  for (var i = 1; i < total; i++) {
    nextWorkingDay = await getNextWorkingDay(nextWorkingDay, 1)
  }
  return nextWorkingDay
}

function getNextWorkingDay (now, extraNotWorkingDay) {
  return new Promise((resolve, reject) => {
    getClosedDays()
      .then((dates) => {
        if (now === null) {
          now = new Date()
        }
        now.setDate(now.getDate() + 1) // add days
        if (now.getDay() === extraNotWorkingDay) { // extra not working day (sat or mon)
          now.setDate(now.getDate() + 1) // add another day
        }
        if (now.getDay() === 0) { // sunday
          now.setDate(now.getDate() + 1) // add another day
        }
        if (now.getDay() === extraNotWorkingDay) { // extra not working day (sat or mon)
          now.setDate(now.getDate() + 1) // add another day
        }
        // now check if that day is a closed day
        while (dates.includes(now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2))) {
          now.setDate(now.getDate() + 1)
        }
        now.setHours(0, 0, 0, 0)
        resolve(now)
      }, (error) => {
        return reject(error)
      })
  })
}

async function getNextPostNLDeliveryDay () {
  let now = new Date()
  let packagingDay = await getPackagingDay(now)
  let deliveryDay = await getNextWorkingDayPostNL(packagingDay, 1)
  return deliveryDay
}

async function getNextDPDDeliveryDay () {
  let now = new Date()
  let packagingDay = await getPackagingDay(now)
  let deliveryDay = await getNextWorkingDayDPD(packagingDay, 2)
  return deliveryDay
}

async function getNextDPDDeliveryDayByCountry (country) {
  // not meant for NL/BE!
  let now = new Date()
  let packagingDay = await getPackagingDay(now)

  let closeCountries = ['de', 'fr']
  let add = 2
  if (!closeCountries.includes(country.toLowerCase())) {
    add += 3
  }

  let deliveryDay = await getNextWorkingDayDPD(packagingDay, add)
  return deliveryDay
}

function getNextDeliveryDay (country, pickup) {
  if (['be', 'nl'].includes(country)) {
    if (pickup) {
      return daysService.getNextDPDDeliveryDay()
    } else {
      return daysService.getNextPostNLDeliveryDay()
    }
  } else {
    return daysService.getNextDPDDeliveryDayByCountry(country)
  }
}



// WEBPACK FOOTER //
// ./src/services/days.service.js